module.exports = __webpack_public_path__ + "img/MD.b3d00959.png";